'use strict';

const $ = window.jQuery;
import Swiper from 'swiper';

export default class Gutenberg {
    constructor() {
        if ($('.the-content').length <= 0) {
            return;
        }

        // Accordion
        if ($('.sn-accordion').length >= 0) {
            const $title = $('.sn-accordion__title');
            const $panel = $('.sn-accordion__content');

            $title.on('click', function () {
                const $sibling = $(this).siblings('.sn-accordion__content');
                const $wrapper = $(this).closest('.sn-accordion-wrapper');

                $(this).parent().toggleClass('is-active');
                $(this).find('button').attr('aria-expanded', (i, attr) => attr === 'true' ? 'false' : 'true');
                $sibling.slideToggle();

                if (!$wrapper.data('multiple')) {
                    $title.not(this).parent().removeClass('is-active');
                    $title.not(this).find('button').attr('aria-expanded', 'false');
                    $panel.not($sibling).slideUp();
                }
            });
        }

        // Carousel
        if ($('.carousel').length >= 0) {
            const carousel = new Swiper('.carousel-wrapper', {
                wrapperClass: 'carousel',
                slideClass: 'carousel__figure',
                slidesPerView: 1,
                spaceBetween: 0,
                centeredSlides: true,
                pagination: false,
                grabCursor: true,
                parallax: true,
                speed: 1000,
                navigation: {
                    prevEl: '.carousel-nav__btn--prev',
                    nextEl: '.carousel-nav__btn--next'
                },
                on: {
                    'slideChange': function (swiper) {
                        swiper.$el.find('.carousel-current').html(swiper.activeIndex + 1);
                    }
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 120
                    }
                }
            });
        }
    }
}
